/**
 * Created by henriquemasca on 10/1/19.
 */
import React, { Component } from "react";
import { withTranslation } from 'react-i18next';

import "./home.css";

class HowToBuy extends Component {
	
	state = {clicked: true};
	
	howClick = () => {
		this.setState({clicked: !this.state.clicked})
	};
    
  render() {
  	
  	const { t } = this.props;
    return (
      <div >
	     
				<hr/>
				<button className="btn  btn-cta cta-item text-center"
				        onClick={() => this.howClick()}>
					{t('homepage.howtobuy.button')} {/*Como Comprar em 4 passos */}
				</button>
				<hr/>

				<div hidden={this.state.clicked}>
					
					<p>
						{t('homepage.howtobuy.step1')}
						{/*1 - Faça o Login com seu Gmail (clique no botão do Google no canto superior direito) e crie sua conta.*/}
					</p>
					<p>
						{t('homepage.howtobuy.step2')}
						{/*2 - Escolha sua experiência (Experiências >> Escolha o Winvite >> Consulte os preços)*/}
					</p>
					<p>
						{t('homepage.howtobuy.step3')}
						{/*3 - Utilizando o seu cartão de crédito deposite o valor na sua conta  (Login >> Wallet >> Depositar)*/}
					</p>
					
					<p>
						{t('homepage.howtobuy.step4')}
						{/*4 - Clique no botão verde (contendo o preço) para adquirir o seu Winvite.*/}
					</p>
				
				</div>
	      
      </div>
    );
  }
}

export default withTranslation()(HowToBuy);


// WEBPACK FOOTER //
// ./src/containers/HomePage/HowToBuy.js